import React from "react";
// const icons = [
//   {
//       id:1,
//       iconname:"Step-by-step event details",
//       svg:( 
//          <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="32"
//         height="32"
//         viewBox="0 0 32 32"
//         fill="none"
//       >
//         <path
//           d="M21.2754 4V7.94903"
//           stroke="#26B8E3"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M11.582 4V7.94903"
//           stroke="#26B8E3"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M27.2253 16.6986V11.4652C27.2357 7.85738 25.0459 5.89325 21.5107 5.89325H11.3501C7.82525 5.89325 5.625 7.85738 5.625 11.4652V22.3251C5.625 25.99 7.82525 27.9982 11.3501 27.9982H16.708"
//           stroke="#26B8E3"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M10.7607 13.2008H22.0889"
//           stroke="#26B8E3"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M21.9799 26.6376L21.851 26.2887C21.3647 24.9725 20.3286 23.9349 19.0145 23.448L18.666 23.3188L19.0145 23.1897C20.3286 22.7027 21.3647 21.6651 21.851 20.3491L21.9799 20L22.1089 20.3491C22.5952 21.6651 23.6313 22.7027 24.9454 23.1897L25.294 23.3188L24.9454 23.448C23.6313 23.9349 22.5952 24.9725 22.1089 26.2887L21.9799 26.6376Z"
//           stroke="#26B8E3"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M28.7611 28.2235C28.5419 27.5025 27.9786 26.9383 27.2588 26.7188C27.9786 26.4995 28.5419 25.9352 28.7611 25.2143C28.9802 25.9352 29.5435 26.4995 30.2634 26.7188C29.5435 26.9383 28.9802 27.5025 28.7611 28.2235Z"
//           stroke="#26B8E3"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//       </svg>
//       )

//   },
//   {
//       id:2,
//       iconname:"Send invitation",
//       svg:(
//         <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="33"
//                   height="32"
//                   viewBox="0 0 33 32"
//                   fill="none"
//                 >
//                   <path
//                     d="M21.6084 4V7.94903"
//                     stroke="#F7735B"
//                     stroke-width="2"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                   <path
//                     d="M11.915 4V7.94903"
//                     stroke="#F7735B"
//                     stroke-width="2"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                   <path
//                     d="M27.5583 16.6986V11.4652C27.5687 7.85738 25.3789 5.89325 21.8437 5.89325H11.6831C8.15826 5.89325 5.95801 7.85738 5.95801 11.4652V22.3251C5.95801 25.99 8.15826 27.9982 11.6831 27.9982H17.041"
//                     stroke="#F7735B"
//                     stroke-width="2"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                   <path
//                     d="M11.0938 13.2008H22.4219"
//                     stroke="#F7735B"
//                     stroke-width="2"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                   <path
//                     d="M22.313 26.6376L22.184 26.2887C21.6977 24.9725 20.6617 23.9349 19.3475 23.448L18.999 23.3188L19.3475 23.1897C20.6617 22.7027 21.6977 21.6651 22.184 20.3491L22.313 20L22.4419 20.3491C22.9282 21.6651 23.9643 22.7027 25.2784 23.1897L25.627 23.3188L25.2784 23.448C23.9643 23.9349 22.9282 24.9725 22.4419 26.2887L22.313 26.6376Z"
//                     stroke="#F7735B"
//                     stroke-width="2"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                   <path
//                     d="M29.0941 28.2235C28.8749 27.5025 28.3116 26.9383 27.5918 26.7188C28.3116 26.4995 28.8749 25.9352 29.0941 25.2143C29.3132 25.9352 29.8765 26.4995 30.5964 26.7188C29.8765 26.9383 29.3132 27.5025 29.0941 28.2235Z"
//                     stroke="#F7735B"
//                     stroke-width="2"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />
//                 </svg>
//       )
//   },
//   {
//       id: 7,
//       iconname: "Book a Priest",
//       svg:(
//         <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="32"
//         height="32"
//         viewBox="0 0 32 32"
//         fill="none"
//       >
//         <path
//           d="M9.42769 27.3344C7.40233 27.3344 6.17844 26.0202 6.0918 24.1898C6.0918 20.464 10.1245 19.1788 16.2005 19.1354C22.2876 19.1932 26.3311 20.4784 26.3093 24.1898C26.2119 26.0202 24.9952 27.3344 22.9735 27.3344H9.42769Z"
//           stroke="#C7905C"
//           stroke-width="2"
//           stroke-miterlimit="10"
//         />
//         <path
//           d="M16.2111 14.8837C19.0324 14.8837 21.3196 12.5966 21.3196 9.7752C21.3196 6.95383 19.0324 4.66666 16.2111 4.66666C13.3898 4.66666 11.1025 6.95383 11.1025 9.7752C11.1025 12.5966 13.3898 14.8837 16.2111 14.8837Z"
//           stroke="#C7905C"
//           stroke-width="2"
//           stroke-miterlimit="10"
//         />
//       </svg>
//       )
//   },
//   {
//       id:8,
//       iconname:"Rent from tent houses",
//       svg:(
//         <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="32"
//         height="32"
//         viewBox="0 0 32 32"
//         fill="none"
//       >
//         <path
//           d="M21.8877 4V8.29768"
//           stroke="#C7905C"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M11.4561 4V8.29768"
//           stroke="#C7905C"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M22.6541 5.98175L10.7022 5.98294C7.19148 5.98294 5 7.93795 5 11.5314V22.3492C5 25.9994 7.19148 27.9997 10.7022 27.9997L22.6438 27.9985C26.1649 27.9985 28.346 26.0332 28.346 22.4385V11.5302C28.3564 7.93676 26.1752 5.98175 22.6541 5.98175Z"
//           stroke="#C7905C"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M17.275 12.73L18.2684 14.7175C18.367 14.9131 18.5563 15.0482 18.7728 15.0796L20.9984 15.399C21.359 15.4468 21.6131 15.7787 21.5651 16.1383C21.5456 16.2859 21.477 16.4235 21.3692 16.527L19.7598 18.0728C19.603 18.2242 19.529 18.4424 19.5666 18.6582L19.9479 20.8412C20.0062 21.2047 19.7586 21.5479 19.394 21.6071C19.2502 21.63 19.1036 21.606 18.9752 21.5378L16.9883 20.5068C16.7924 20.4059 16.5591 20.4059 16.3632 20.5068L14.375 21.5378C14.0495 21.7107 13.6436 21.5871 13.4711 21.2614C13.4036 21.1327 13.379 20.9851 13.4023 20.8412L13.7823 18.6582C13.8212 18.4438 13.7487 18.2242 13.5904 18.0728L11.9796 16.527C11.719 16.2746 11.7099 15.8582 11.9615 15.5956C12.0652 15.4884 12.2027 15.4191 12.3505 15.4002L14.576 15.0796C14.7939 15.0494 14.982 14.9143 15.0806 14.7187L16.0766 12.73C16.2491 12.3994 16.655 12.2708 16.9858 12.4411C17.109 12.5054 17.2102 12.6064 17.275 12.73Z"
//           stroke="#C7905C"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//       </svg>
//       )
//   },
//   {
//       id:9,
//       iconname:"Order Catering",
//       svg:(
//         <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="32"
//         height="32"
//         viewBox="0 0 32 32"
//         fill="none"
//       >
//         <path
//           d="M26.8409 23.2292L26.4816 24.4072C26.0833 25.7148 24.8768 26.6087 23.5108 26.6087H8.49064C7.12459 26.6087 5.91809 25.7148 5.51983 24.4072L5.16047 23.2292M4 23.2292H28"
//           stroke="#006C19"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M17.5507 6.94156C17.5507 6.08535 16.8567 5.3913 16.0005 5.3913C15.1442 5.3913 14.4502 6.08535 14.4502 6.94156C14.4502 7.79778 15.1446 8.49138 16.0007 8.49138C16.857 8.49138 17.5507 7.79778 17.5507 6.94156Z"
//           stroke="#006C19"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//         <path
//           d="M5.33879 19.6975C5.03393 13.6015 9.8949 8.49152 15.9987 8.49152C22.1025 8.49152 26.9634 13.6015 26.6598 19.6975"
//           stroke="#006C19"
//           stroke-width="2"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />
//       </svg>
//       )
//   }
// ]

const icons2 = [
  {
      id:1,
      iconname:"Checklist / To-do list Instructions",
      svg:( 
      <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="currentColor"
          >
            <path
              d="M18.549 11H19.596C19.8736 11 20.1399 10.8946 20.3363 10.7071C20.5326 10.5196 20.6429 10.2652 20.6429 10V9C20.6429 8.73478 20.5326 8.48043 20.3363 8.29289C20.1399 8.10536 19.8736 8 19.596 8H18.549C18.2714 8 18.0051 8.10536 17.8087 8.29289C17.6124 8.48043 17.5021 8.73478 17.5021 9V10C17.5021 10.2652 17.6124 10.5196 17.8087 10.7071C18.0051 10.8946 18.2714 11 18.549 11ZM7.03259 12H12.2673C12.545 12 12.8113 11.8946 13.0076 11.7071C13.204 11.5196 13.3143 11.2652 13.3143 11C13.3143 10.7348 13.204 10.4804 13.0076 10.2929C12.8113 10.1054 12.545 10 12.2673 10H7.03259C6.75493 10 6.48863 10.1054 6.29229 10.2929C6.09595 10.4804 5.98564 10.7348 5.98564 11C5.98564 11.2652 6.09595 11.5196 6.29229 11.7071C6.48863 11.8946 6.75493 12 7.03259 12ZM23.7838 4H2.8448C2.56713 4 2.30084 4.10536 2.1045 4.29289C1.90815 4.48043 1.79785 4.73478 1.79785 5V19C1.79785 19.2652 1.90815 19.5196 2.1045 19.7071C2.30084 19.8946 2.56713 20 2.8448 20H23.7838C24.0614 20 24.3277 19.8946 24.5241 19.7071C24.7204 19.5196 24.8307 19.2652 24.8307 19V5C24.8307 4.73478 24.7204 4.48043 24.5241 4.29289C24.3277 4.10536 24.0614 4 23.7838 4ZM22.7368 18H3.89175V6H22.7368V18ZM7.03259 16H12.2673C12.545 16 12.8113 15.8946 13.0076 15.7071C13.204 15.5196 13.3143 15.2652 13.3143 15C13.3143 14.7348 13.204 14.4804 13.0076 14.2929C12.8113 14.1054 12.545 14 12.2673 14H7.03259C6.75493 14 6.48863 14.1054 6.29229 14.2929C6.09595 14.4804 5.98564 14.7348 5.98564 15C5.98564 15.2652 6.09595 15.5196 6.29229 15.7071C6.48863 15.8946 6.75493 16 7.03259 16Z"
              fill="currentColor"
            />
          </svg>
      )

  },
  {
      id:2,
      iconname:"Send invitation",
      svg:(
          <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M13.2216 8.93538L4.21245 13.6764C3.3958 14.1063 2.43645 13.4009 2.65115 12.5287L3.75969 8.0269L2.65115 3.5239C2.43645 2.65166 3.3958 1.94687 4.21245 2.37674L13.2216 7.11778C13.9675 7.5108 13.9675 8.54236 13.2216 8.93538Z"
                  stroke={ "currentColor"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.34087 8.01172L3.78516 8.03988"
                  stroke={ "currentColor"}
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
      )
  },
  {
      id: 7,
      iconname: "Book a Priest",
      svg:(
       <svg
  xmlns="http://www.w3.org/2000/svg"
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
>
  <path
    d="M9.42769 27.3344C7.40233 27.3344 6.17844 26.0202 6.0918 24.1898C6.0918 20.464 10.1245 19.1788 16.2005 19.1354C22.2876 19.1932 26.3311 20.4784 26.3093 24.1898C26.2119 26.0202 24.9952 27.3344 22.9735 27.3344H9.42769Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-miterlimit="10"
  />
  <path
    d="M16.2111 14.8837C19.0324 14.8837 21.3196 12.5966 21.3196 9.7752C21.3196 6.95383 19.0324 4.66666 16.2111 4.66666C13.3898 4.66666 11.1025 6.95383 11.1025 9.7752C11.1025 12.5966 13.3898 14.8837 16.2111 14.8837Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-miterlimit="10"
  />
</svg>

      )
  },
  {
      id:8,
      iconname:"Rent from tent houses",
      svg:(
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M22 5H2C1.73478 5 1.48043 5.10536 1.29289 5.29289C1.10536 5.48043 1 5.73478 1 6V10C1.00174 10.6189 1.19488 11.2222 1.55294 11.7271C1.911 12.2319 2.41645 12.6137 3 12.82V22C3 22.2652 3.10536 22.5196 3.29289 22.7071C3.48043 22.8946 3.73478 23 4 23H20C20.2652 23 20.5196 22.8946 20.7071 22.7071C20.8946 22.5196 21 22.2652 21 22V12.82C21.5835 12.6137 22.089 12.2319 22.4471 11.7271C22.8051 11.2222 22.9983 10.6189 23 10V6C23 5.73478 22.8946 5.48043 22.7071 5.29289C22.5196 5.10536 22.2652 5 22 5ZM15 7H17V10C17 10.2652 16.8946 10.5196 16.7071 10.7071C16.5196 10.8946 16.2652 11 16 11C15.7348 11 15.4804 10.8946 15.2929 10.7071C15.1054 10.5196 15 10.2652 15 10V7ZM11 7H13V10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 10.8946 11.2929 10.7071C11.1054 10.5196 11 10.2652 11 10V7ZM7 7H9V10C9 10.2652 8.89464 10.5196 8.70711 10.7071C8.51957 10.8946 8.26522 11 8 11C7.73478 11 7.48043 10.8946 7.29289 10.7071C7.10536 10.5196 7 10.2652 7 10V7ZM4 11C3.73478 11 3.48043 10.8946 3.29289 10.7071C3.10536 10.5196 3 10.2652 3 10V7H5V10C5 10.2652 4.89464 10.5196 4.70711 10.7071C4.51957 10.8946 4.26522 11 4 11ZM14 21H10V19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19V21ZM19 21H16V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15C10.9391 15 9.92172 15.4214 9.17157 16.1716C8.42143 16.9217 8 17.9391 8 19V21H5V12.82C5.36757 12.6836 5.70664 12.4801 6 12.22C6.55002 12.712 7.26207 12.9839 8 12.9839C8.73793 12.9839 9.44998 12.712 10 12.22C10.55 12.712 11.2621 12.9839 12 12.9839C12.7379 12.9839 13.45 12.712 14 12.22C14.55 12.712 15.2621 12.9839 16 12.9839C16.7379 12.9839 17.45 12.712 18 12.22C18.2934 12.4801 18.6324 12.6836 19 12.82V21ZM21 10C21 10.2652 20.8946 10.5196 20.7071 10.7071C20.5196 10.8946 20.2652 11 20 11C19.7348 11 19.4804 10.8946 19.2929 10.7071C19.1054 10.5196 19 10.2652 19 10V7H21V10ZM4.3 3H20C20.2652 3 20.5196 2.89464 20.7071 2.70711C20.8946 2.51957 21 2.26522 21 2C21 1.73478 20.8946 1.48043 20.7071 1.29289C20.5196 1.10536 20.2652 1 20 1H4.3C4.03478 1 3.78043 1.10536 3.59289 1.29289C3.40536 1.48043 3.3 1.73478 3.3 2C3.3 2.26522 3.40536 2.51957 3.59289 2.70711C3.78043 2.89464 4.03478 3 4.3 3Z"
              fill="currentColor"
            />
          </svg>
      )
  },
  {
      id:9,
      iconname:"Order Catering",
      svg:(
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="24"
            viewBox="0 0 28 24"
            fill="currentColor"
          >
            <path
              d="M22.0248 2.00003C21.7291 2.00003 21.4455 2.10539 21.2364 2.29292C21.0273 2.48046 20.9098 2.73481 20.9098 3.00003V8.46003L19.7948 9.13003V3.00003C19.7948 2.73481 19.6773 2.48046 19.4682 2.29292C19.2591 2.10539 18.9755 2.00003 18.6798 2.00003C18.3841 2.00003 18.1005 2.10539 17.8914 2.29292C17.6823 2.48046 17.5648 2.73481 17.5648 3.00003V9.13003L16.4498 8.46003V3.00003C16.4498 2.73481 16.3323 2.48046 16.1232 2.29292C15.9141 2.10539 15.6305 2.00003 15.3348 2.00003C15.0391 2.00003 14.7555 2.10539 14.5464 2.29292C14.3373 2.48046 14.2198 2.73481 14.2198 3.00003V9.00003C14.2208 9.16474 14.2671 9.32668 14.3546 9.47148C14.4421 9.61628 14.5682 9.73944 14.7216 9.83003L17.5648 11.54V21C17.5648 21.2652 17.6823 21.5196 17.8914 21.7071C18.1005 21.8947 18.3841 22 18.6798 22C18.9755 22 19.2591 21.8947 19.4682 21.7071C19.6773 21.5196 19.7948 21.2652 19.7948 21V11.54L22.6381 9.83003C22.7914 9.73944 22.9175 9.61628 23.005 9.47148C23.0926 9.32668 23.1389 9.16474 23.1398 9.00003V3.00003C23.1398 2.73481 23.0223 2.48046 22.8132 2.29292C22.6041 2.10539 22.3205 2.00003 22.0248 2.00003ZM10.8748 2.00003C9.39622 2.00003 7.9782 2.52681 6.93268 3.4645C5.88717 4.40218 5.2998 5.67395 5.2998 7.00003V13C5.2998 13.2652 5.41728 13.5196 5.62638 13.7071C5.83548 13.8947 6.11909 14 6.4148 14H9.7598V21C9.7598 21.2652 9.87728 21.5196 10.0864 21.7071C10.2955 21.8947 10.5791 22 10.8748 22C11.1705 22 11.4541 21.8947 11.6632 21.7071C11.8723 21.5196 11.9898 21.2652 11.9898 21V3.00003C11.9898 2.73481 11.8723 2.48046 11.6632 2.29292C11.4541 2.10539 11.1705 2.00003 10.8748 2.00003ZM9.7598 12H7.5298V7.00003C7.52944 6.37938 7.74372 5.7739 8.14312 5.26705C8.54251 4.76019 9.10736 4.37691 9.7598 4.17003V12Z"
              fill="currentColor"
            />
          </svg>
      )
  }
]
// Icon Component to display the icon based on id passed as prop
export const Icon = ({ id, size = 24,className }) => {
  const icon = icons2.find(icon => icon.id === id);
  if (!icon) return null;
  
  return React.cloneElement(icon.svg, {
    width: size,
    height: size,    
    className,
  });
};
